import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useContext } from "react";
import { AppContext } from "../app-context";
import { ResponseSelector } from "../types/globalapi/response-selector";
import { UserLocationContext } from "../UserLocation/UserLocationContext";
import { get } from "./getGeneric";

const useFiltersQuery = <T, U>(options?: {select?: ResponseSelector<T, U>}) => {

  const { globalApi } = useContext(AppContext);
  const { postalCode } = useContext(UserLocationContext);

  const url = `${globalApi}/inventory-app/filters`;

  const queryOptions: UseQueryOptions<T | U> = {
    queryKey: ['filters-static'],
    queryFn: () => get<T>(url),
    enabled: !!postalCode,
  };

  if (options?.select) {
    const { select } = options;
    queryOptions.select = (res) => select(res as T) as U;
  }

  return useQuery(queryOptions);
}

export default useFiltersQuery;
